exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3[data-v-473e5773] {\n  text-align: center;\n}\nlabel[data-v-473e5773] {\n  padding-left: 10px;\n}\n.row .col-12[data-v-473e5773] {\n  padding-top: 6px;\n  padding-bottom: 6px;\n}", ""]);

// exports
